exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.main {\n  margin:1ex;\n  padding:1ex;\n  border: thin solid silver;\n  border-radius: 8px;\n}\n\n.error {\n  outline: 2px solid red;\n}\n\nbutton.delete {\n  color:red;\n  margin-left:200px;\n}\n\nbutton.delete.confirm {\n  margin-left: 30px;\n  outline: 2px solid red;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/project-box/project-box.component.css
// module id = ../../../../../src/app/project-box/project-box.component.css
// module chunks = main